class CountUpElement extends HTMLElement {
  constructor() {
    super();
    this.observerInstance = null;
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  connectedCallback() {
    this.setupObserver();
  }

  disconnectedCallback() {
    if (this.observerInstance) {
      this.observerInstance.disconnect();
    }
  }

  setupObserver() {
    this.observerInstance = new IntersectionObserver((entries) => this.handleIntersection(entries), { threshold: 0.1 });
    this.observerInstance.observe(this);
  }

  handleIntersection(entries) {
    const entry = entries[0];
    if (entry.isIntersecting && !this.classList.contains('animated')) {
      this.startAnimation();
    }
  }

  startAnimation() {
    this.classList.add('animated');
    const endValue = parseInt(this.textContent.trim(), 10);

    if (!isNaN(endValue)) {
      if (this.prefersReducedMotion) {
        this.textContent = endValue.toString();
      } else {
        this.textContent = '0';
        this.animateCountUp(endValue);
      }
    } else {
      console.warn('Invalid number inside element:', this);
    }
  }

  animateCountUp(endValue, duration = 1000) {
    let startTime = null;

    const updateValue = (currentTime) => {
      if (!startTime) startTime = currentTime;
      const elapsedTime = currentTime - startTime;
      const progress = Math.min(elapsedTime / duration, 1);
      const currentValue = Math.round(endValue * progress);

      this.textContent = currentValue;

      if (progress < 1) {
        requestAnimationFrame(updateValue);
      } else {
        this.textContent = endValue;
      }
    };

    requestAnimationFrame(updateValue);
  }
}

customElements.define('count-up', CountUpElement);
